import * as React from 'react';
import { UitkLink } from 'uitk-react-link';

var UitkProgressChangeLink = function (_a) {
    var changeFlightOnClickCallback = _a.changeFlightOnClickCallback, changeSelection = _a.changeSelection, index = _a.index;
    var action = changeSelection.action, a11yLabel = changeSelection.a11yLabel, label = changeSelection.label;
    var resource = action.resource;
    var handleOnClick = function (event) {
        var _a = action.analytics, linkName = _a.linkName, referrerId = _a.referrerId;
        changeFlightOnClickCallback(referrerId, linkName, event, index);
    };
    if (resource === null || resource === void 0 ? void 0 : resource.relativePath) {
        return (React.createElement(UitkLink, { size: "small" },
            React.createElement("a", { href: resource.relativePath, onClick: handleOnClick, "aria-label": a11yLabel }, label)));
    }
    return null;
};
UitkProgressChangeLink.displayName = 'UitkProgressChangeLink';

export { UitkProgressChangeLink };
